import { Layer } from '@pixi/layers';
import {ReasonID, Rectangle} from '@gongxigames/framework/core';
import {BetInfo, UIButtons} from '@gongxigames/framework/slot/types';

export type UIElementsNames = 'TotalBetOpen';
export type UIElementsChangeVisibilityEvent = {
    name: UIElementsNames;
};

export type UIButtonsChangeEnableEvent = {
    name: UIButtons;
    reason: ReasonID;
};

export enum UIElements {
    TOTAL_BET_PANEL = 'TotalBetPanel'
}

export type UIElementsSwapLayerEvent = {
    layer: Layer;
    element: UIElements;
};

export type UIElementRepositionNames = '_totalBetOpenButton'| '_betIncButton' | '_betDecButton' | 'turboButtonOn' | 'turboButtonOff';

export type UIElementRepositionData = {
    name: UIElementRepositionNames;
    x?: number;
    y?: number;
};

export type UIEvents = {
    'General.UI.ENABLE': ReasonID;
    'General.UI.DISABLE': ReasonID;
    'General.UI.Button.DISABLE': UIButtonsChangeEnableEvent;
    'General.UI.Button.ENABLE': UIButtonsChangeEnableEvent;
    'General.UI.ENABLE_KEYBOARD': ReasonID;
    'General.UI.DISABLE_KEYBOARD': ReasonID;
    'General.UI.SPACEBAR_DOWN': void;
    'General.UI.SPACEBAR_UP': void;
    'General.UI.KEY_DOWN': number;
    'General.UI.KEY_UP': number;
    'General.UI.HideElement': UIElementsChangeVisibilityEvent;
    'General.UI.ShowElement': UIElementsChangeVisibilityEvent;
    'General.UI.BALANCE.UPDATED': number;
    'General.UI.BALANCE_FIELD.UPDATED': Rectangle;
    'General.UI.BET.CHANGED': BetInfo;
    'General.UI.SWAP_LAYER': UIElementsSwapLayerEvent;
    'General.UI.RepositionElements': UIElementRepositionData[];
};
